"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTagIdsFilter = exports.selectSportIdsFilter = exports.selectSearchQueryFilter = exports.getIsEventListFilterUsed = exports.getIsEventListEmpty = exports.getEventListV2 = exports.getEventList = exports.getEventListFilters = exports.getEventsIdsV2 = exports.getEventsIds = exports.getIsEventListPolling = exports.getIsEventListLoading = exports.getIsNextPageLoading = exports.getHasNextPage = exports.getNextPageKey = exports.getPage2EventIds = exports.getIsPrevPageLoading = exports.getPrevPageKey = exports.getPage1EventIds = exports.getPage1 = exports.getHasBeforeEventIds = exports.getInactivePagesEventIds = exports.getBeforePageEventIds = exports.getInactivePages = exports.getPage2Number = exports.getPage1Number = exports.getListConfig = exports.getEventListStateByKey = exports.getIsEventListInitialized = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const isEmpty_1 = __importDefault(require("../../../utils/functions/isEmpty"));
const _reduxjs_1 = require("../../../utils/@reduxjs");
const constants_1 = require("../constants");
const eventsSelectors_1 = require("./eventsSelectors");
const getListsState = (state) => state.eventsProvider.lists;
const getIsEventListInitialized = (state, listKey) => {
    return getListsState(state)[listKey] !== undefined;
};
exports.getIsEventListInitialized = getIsEventListInitialized;
const getEventListStateByKey = (state, listKey) => {
    return getListsState(state)[listKey];
};
exports.getEventListStateByKey = getEventListStateByKey;
const getListConfig = (state, listKey) => {
    return (0, exports.getEventListStateByKey)(state, listKey).config;
};
exports.getListConfig = getListConfig;
const getPage1Number = (state, listKey) => {
    return (0, exports.getEventListStateByKey)(state, listKey).page1Number;
};
exports.getPage1Number = getPage1Number;
const getPage2Number = (state, listKey) => {
    return (0, exports.getEventListStateByKey)(state, listKey).page2Number;
};
exports.getPage2Number = getPage2Number;
const getBeforePage = (state, listKey) => {
    return (0, exports.getEventListStateByKey)(state, listKey).before;
};
const getInactivePages = (state, listKey) => {
    return (0, exports.getEventListStateByKey)(state, listKey).inactivePages;
};
exports.getInactivePages = getInactivePages;
const getBeforePageEventIds = (state, listKey) => {
    return getBeforePage(state, listKey).eventIds;
};
exports.getBeforePageEventIds = getBeforePageEventIds;
exports.getInactivePagesEventIds = (0, toolkit_1.createSelector)([exports.getInactivePages], (pages) => {
    return pages.flatMap((el) => el.eventIds);
});
const getHasBeforeEventIds = (state, listKey) => {
    return (0, exports.getBeforePageEventIds)(state, listKey).length > 0;
};
exports.getHasBeforeEventIds = getHasBeforeEventIds;
const getPage1 = (state, listKey) => {
    return (0, exports.getEventListStateByKey)(state, listKey).page1;
};
exports.getPage1 = getPage1;
const getPage1EventIds = (state, listKey) => {
    return (0, exports.getPage1)(state, listKey).eventIds;
};
exports.getPage1EventIds = getPage1EventIds;
const getPrevPageKey = (state, listKey) => {
    return (0, exports.getPage1)(state, listKey).paginationKeyBackward;
};
exports.getPrevPageKey = getPrevPageKey;
const getIsPrevPageLoading = (state, listKey) => {
    return !!(0, exports.getPage1)(state, listKey).loading;
};
exports.getIsPrevPageLoading = getIsPrevPageLoading;
const getIsPrevPagePolling = (state, listKey) => {
    return !!(0, exports.getPage1)(state, listKey).polling;
};
const getPage2 = (state, listKey) => {
    return (0, exports.getEventListStateByKey)(state, listKey).page2;
};
const getPage2EventIds = (state, listKey) => {
    return getPage2(state, listKey).eventIds;
};
exports.getPage2EventIds = getPage2EventIds;
const getNextPageKey = (state, listKey) => {
    return getPage2(state, listKey).paginationKeyForward;
};
exports.getNextPageKey = getNextPageKey;
const getHasNextPage = (state, listKey) => {
    return !!(0, exports.getNextPageKey)(state, listKey);
};
exports.getHasNextPage = getHasNextPage;
const getIsNextPageLoading = (state, listKey) => {
    return !!getPage2(state, listKey).loading;
};
exports.getIsNextPageLoading = getIsNextPageLoading;
const getIsNextPagePolling = (state, listKey) => {
    return !!getPage2(state, listKey).polling;
};
const getIsEventListLoading = (state, listKey) => {
    return ((0, exports.getIsPrevPageLoading)(state, listKey) || (0, exports.getIsNextPageLoading)(state, listKey));
};
exports.getIsEventListLoading = getIsEventListLoading;
const getIsEventListPolling = (state, listKey) => {
    return (getIsPrevPagePolling(state, listKey) || getIsNextPagePolling(state, listKey));
};
exports.getIsEventListPolling = getIsEventListPolling;
exports.getEventsIds = (0, toolkit_1.createSelector)([exports.getBeforePageEventIds, exports.getPage1EventIds, exports.getPage2EventIds], (beforeEventIds, eventsIds1, eventsIds2) => {
    return [...beforeEventIds, ...eventsIds1, ...eventsIds2];
});
exports.getEventsIdsV2 = (0, toolkit_1.createSelector)([exports.getInactivePagesEventIds, exports.getPage1EventIds, exports.getPage2EventIds], (eventIds, eventsIds1, eventsIds2) => {
    return [...eventIds, ...eventsIds1, ...eventsIds2];
});
const getEventListFilters = (state, listKey) => {
    var _a, _b;
    return ((_b = (_a = (0, exports.getEventListStateByKey)(state, listKey)) === null || _a === void 0 ? void 0 : _a.filters) !== null && _b !== void 0 ? _b : constants_1.eventListDefaultFilters);
};
exports.getEventListFilters = getEventListFilters;
exports.getEventList = (0, toolkit_1.createSelector)([exports.getEventsIds, eventsSelectors_1.getEvents], (eventsIds, events) => {
    return (0, _reduxjs_1.getValues)(eventsIds, events);
});
exports.getEventListV2 = (0, toolkit_1.createSelector)([exports.getEventsIdsV2, eventsSelectors_1.getEvents], (eventsIds, events) => {
    return (0, _reduxjs_1.getValues)(eventsIds, events);
});
exports.getIsEventListEmpty = (0, toolkit_1.createSelector)([eventsSelectors_1.getEvents], (events) => {
    return (0, isEmpty_1.default)(events);
});
exports.getIsEventListFilterUsed = (0, toolkit_1.createSelector)([exports.getEventListFilters], (filters) => {
    return !(0, react_fast_compare_1.default)(filters, constants_1.eventListDefaultFilters);
});
const selectSearchQueryFilter = (state, listKey) => {
    const filters = (0, exports.getEventListFilters)(state, listKey);
    return filters.searchQuery;
};
exports.selectSearchQueryFilter = selectSearchQueryFilter;
const selectSportIdsFilter = (state, listKey) => {
    const filters = (0, exports.getEventListFilters)(state, listKey);
    return filters.sportIds;
};
exports.selectSportIdsFilter = selectSportIdsFilter;
const selectTagIdsFilter = (state, listKey) => {
    const filters = (0, exports.getEventListFilters)(state, listKey);
    return filters.tagIds;
};
exports.selectTagIdsFilter = selectTagIdsFilter;
//# sourceMappingURL=listsSelectors.js.map